import { render, staticRenderFns } from "./KioskBooking.vue?vue&type=template&id=9ac80608&scoped=true&"
import script from "./KioskBooking.vue?vue&type=script&lang=js&"
export * from "./KioskBooking.vue?vue&type=script&lang=js&"
import style0 from "./KioskBooking.vue?vue&type=style&index=0&id=9ac80608&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ac80608",
  null
  
)

export default component.exports